'use client';

import { useEffect } from 'react';

import { syncBypassStatus } from '@/utils/comingSoon';

export function ComingSoonSync() {
  useEffect(() => {
    // Sync bypass status from cookie to localStorage on app load
    syncBypassStatus();
  }, []);

  return null; // This component doesn't render anything
}
